import {
  RemoteExportStudentsWorkloadAchievement,
  RemoteGetStudentsWorkloadAchievement,
} from 'data/usecases';
import {
  ExportStudentsWorkloadAchievementUseCaseInterface,
  GetStudentsWorkloadAchievementUseCaseInterface,
} from 'domain/usecases';
import {
  makeApiUrlStudentsWorkloadAchievement,
  makeApiUrlStudentsWorkloadAchievementExportExcel,
  makeApiUrlStudentsWorkloadAchievementExportPdf,
} from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetStudentsWorkloadAchievement =
  (): GetStudentsWorkloadAchievementUseCaseInterface =>
    new RemoteGetStudentsWorkloadAchievement(
      makeApiUrlStudentsWorkloadAchievement(),
      makeAxiosHttpClient(),
    );

export const makeExportStudentsWorkloadAchievement =
  (): ExportStudentsWorkloadAchievementUseCaseInterface =>
    new RemoteExportStudentsWorkloadAchievement(
      makeApiUrlStudentsWorkloadAchievementExportPdf(),
      makeApiUrlStudentsWorkloadAchievementExportExcel(),
      makeAxiosHttpClient(),
    );
